import { useEffect } from "react";
import {
  CardRouded,
  ContainerV2,
  H1,
  InfoV2,
  MessageErroFormV2,
  P,
  SelectableOptionCardV2,
} from "../../Atoms";
import { AsyncSimpleSelectV2 } from "../../Atoms/Selects/AsyncSelectV2";
import { Tracking } from "../../../services/Tracking";
import { ISelectOptions } from "../../../types/inputs";
import { useBatchDelivery } from "./useBatchDelivery";

export const BatchDelivery = () => {
  const {
    stepIndicator,
    modalidade,
    handleModalidadeChange,
    loadCidadeOptions,
    selectedCidade,
    handleCidadeChange,
    cidadeError,
    loadOptions,
    selectedConcessionaria,
    setSelectedConcessionaria,
    concessionariaError,
    handleSubmit,
  } = useBatchDelivery();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento-lote/delivery:pageview");
  }, []);

  return (
    <ContainerV2 nextButton={{ title: "Avançar", onClick: handleSubmit }}>
      {stepIndicator}

      <div className="pt-8">
        <H1 className="mb-4">Delivery</H1>
        <P className="mb-10">
          Escolha se a equipe vai até o endereço de cada cliente ou a uma
          concessionária única.
        </P>
      </div>

      <div className="flex flex-col md:flex-row gap-6 mb-8">
        <SelectableOptionCardV2
          variant="tenant"
          name="modalidade-delivery-lote"
          icon={
            <img
              src={
                modalidade === "domicilio"
                  ? "/assets/svgs/icon-home-active.svg"
                  : "/assets/svgs/icon-home-inactive.svg"
              }
              alt=""
            />
          }
          title="Domicílio"
          description="O endereço de atendimento de cada veículo virá da própria planilha importada."
          selected={modalidade === "domicilio"}
          onSelect={() => handleModalidadeChange("domicilio")}
        />

        <SelectableOptionCardV2
          variant="tenant"
          name="modalidade-delivery-lote"
          icon={
            <img
              src={
                modalidade === "concessionaria"
                  ? "/assets/svgs/icon-apartment-active.svg"
                  : "/assets/svgs/icon-apartment-inactive.svg"
              }
              alt=""
            />
          }
          title="Concessionária"
          description="Todos os veículos serão vistoriados em um mesmo pátio de concessionária."
          selected={modalidade === "concessionaria"}
          onSelect={() => handleModalidadeChange("concessionaria")}
        />
      </div>

      {modalidade === "domicilio" ? (
        <>
          <CardRouded className="mb-8">
            <AsyncSimpleSelectV2
              id="cidade"
              label="Cidade"
              required
              data-error={!!cidadeError}
              loadOptions={loadCidadeOptions}
              defaultOptions
              value={selectedCidade}
              onChange={(e: ISelectOptions) => handleCidadeChange(e)}
            />
            {cidadeError && (
              <MessageErroFormV2>{cidadeError}</MessageErroFormV2>
            )}
          </CardRouded>

          <InfoV2 className="flex items-start gap-4 text-left md:text-left">
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="shrink-0"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.82 2H16C17.1 2 18 2.9 18 4V18C18 19.1 17.1 20 16 20H2C1.86 20 1.73 19.99 1.6 19.97C1.21 19.89 0.86 19.69 0.59 19.42C0.41 19.23 0.26 19.02 0.16 18.78C0.06 18.54 0 18.27 0 18V4C0 3.72 0.06 3.46 0.16 3.23C0.26 2.99 0.41 2.77 0.59 2.59C0.86 2.32 1.21 2.12 1.6 2.04C1.73 2.01 1.86 2 2 2H6.18C6.6 0.84 7.7 0 9 0C10.3 0 11.4 0.84 11.82 2ZM4 8V6H14V8H4ZM14 12V10H4V12H14ZM11 14H4V16H11V14ZM9 1.75C9.41 1.75 9.75 2.09 9.75 2.5C9.75 2.91 9.41 3.25 9 3.25C8.59 3.25 8.25 2.91 8.25 2.5C8.25 2.09 8.59 1.75 9 1.75ZM2 18H16V4H2V18Z"
                fill="#20332F"
              />
            </svg>
            <div>
              <p className="font-['Mulish'] text-base font-bold">
                Endereços vêm da planilha
              </p>
              <p className="font-['Mulish'] text-base">
                As colunas: cep, rua, numero, bairro, cidade e uf são
                obrigatórias para cada cliente. Linhas com endereço incompleto
                serão sinalizadas na importação.
              </p>
            </div>
          </InfoV2>
        </>
      ) : (
        <CardRouded className="flex flex-col md:flex-row gap-6">
          <div className="w-full">
            <AsyncSimpleSelectV2
              id="cidade"
              label="Cidade"
              required
              data-error={!!cidadeError}
              loadOptions={loadCidadeOptions}
              defaultOptions
              value={selectedCidade}
              onChange={(e: ISelectOptions) => handleCidadeChange(e)}
            />
            {cidadeError && (
              <MessageErroFormV2>{cidadeError}</MessageErroFormV2>
            )}
          </div>

          <div className="w-full">
            <AsyncSimpleSelectV2
              key={selectedCidade?.value}
              id="concessionaria"
              label="Concessionária"
              required
              data-error={!!concessionariaError}
              loadOptions={loadOptions}
              defaultOptions
              value={selectedConcessionaria}
              onChange={(e: ISelectOptions) => setSelectedConcessionaria(e)}
            />
            {concessionariaError && (
              <MessageErroFormV2>{concessionariaError}</MessageErroFormV2>
            )}
          </div>
        </CardRouded>
      )}
    </ContainerV2>
  );
};
